// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"87":"d5e2b55c34e82d98da51","201":"63d10eeea1c34c1d8baa","742":"6bcf23b4aab9468db511"}[chunkId] + ".chunk.js";
};